import { useParams, Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { colors } from "@/theme";
import { useSettings } from "@/components/Footer";
import { Spinner, EmptyState } from "@/components/common";
import { useIsMobile } from "@/hooks/useMediaQuery";

export default function PolicyPage() {
  const { slug } = useParams();
  const settings = useSettings();
  const isMobile = useIsMobile();

  if (!settings) return <Spinner full />;
  const title = settings.policy_titles?.[slug];
  const body = settings.policies?.[slug];
  const contact = settings.contact || {};

  if (!title) return <EmptyState title="Policy not found" action={<Link to="/" className="btn-primary" style={{ textDecoration: "none" }}>Home</Link>} />;

  const paragraphs = (body || "").split(/\n{2,}|(?<=\.) (?=\[)/).filter(Boolean);

  return (
    <div className="container-max fade-up" style={{ padding: isMobile ? "28px 20px 48px" : "48px 24px 64px", maxWidth: 760 }}>
      <div className="eyebrow" style={{ marginBottom: 10 }}><Link to="/" style={{ color: colors.mutedText, textDecoration: "none" }}>Home</Link> / Consumer Policy</div>
      <h1 className="font-display" style={{ fontSize: isMobile ? 32 : 42, fontWeight: 700, margin: "0 0 20px" }}>{title}</h1>
      <div className="font-body" style={{ fontSize: 15, lineHeight: 1.8, color: colors.onSurfaceSecondary }}>
        {paragraphs.map((p, i) => (
          <p key={i} style={{ marginTop: i ? 16 : 0, background: p.includes("[EDITABLE") ? colors.accentLight : "transparent", padding: p.includes("[EDITABLE") ? "10px 14px" : 0, borderRadius: p.includes("[EDITABLE") ? 8 : 0 }}>{p}</p>
        ))}
      </div>
      <div style={{ marginTop: 32, padding: 20, border: `1px solid ${colors.border}`, borderRadius: 12, background: colors.surfaceSecondary }}>
        <div className="eyebrow" style={{ marginBottom: 12 }}>Need help?</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
          {contact.phone && <a href={`tel:${contact.phone}`} style={{ display: "flex", alignItems: "center", gap: 9, color: colors.onSurface, textDecoration: "none", fontSize: 14 }}><Phone size={15} color={colors.brand} /> {contact.phone}</a>}
          {contact.email && <a href={`mailto:${contact.email}`} style={{ display: "flex", alignItems: "center", gap: 9, color: colors.onSurface, textDecoration: "none", fontSize: 14 }}><Mail size={15} color={colors.brand} /> {contact.email}</a>}
          {contact.address && <span style={{ fontSize: 14, color: colors.mutedText }}>{contact.address}</span>}
        </div>
      </div>
    </div>
  );
}
